<div class="card p-2 flex-1 w-100">
  <div class="d-flex justify-content-between align-items-center mb-1">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb bg-white px-1">
        <li class="breadcrumb-item" *ngFor="let folder of currentPath">
          <a href="javascript:void(0)" (click)="getFiles(folder)">{{
            folder.name
          }}</a>
        </li>
      </ol>
    </nav>
    <div *ngIf="showUpload" class="d-flex align-items-center">
      <input
        #fileInput
        type="file"
        [multiple]="true"
        (change)="onFileSelected($event)"
        style="display: none"
      />
      <div class="position-relative" style="z-index: 10">
        <div class="d-flex border-bottom mr-2 mb-1">
          <span class="bg-white border-0">
            <i class="fa fa-search"></i>
          </span>
          <input
            type="search"
            class="bg-white border-0 w-100"
            placeholder="Search Files..."
            [(ngModel)]="searchTerm"
            (input)="onSearch()"
            (focus)="showResults = true"
            (blur)="hideResultsWithDelay()"
          />
        </div>
        <ul
          class="list-group position-absolute mt-1 px-1 border bg-white"
          style="z-index: 999; width: 250px; max-height: 50vh; overflow-y: auto"
          *ngIf="showResults && searchResults.length > 0"
        >
          <li
            class="list-group-item list-group-item-action w-100"
            *ngFor="let file of searchResults"
            role="button"
            (click)="selectFile(file, true)"
          >
            <i
              class="fa"
              [ngClass]="
                file.type == 'folder'
                  ? 'fa-folder'
                  : file.type == 'file'
                  ? 'fa-file'
                  : file.type == 'symlink'
                  ? 'fa-link'
                  : 'fa-question'
              "
            ></i>
            <span
              ><strong class="d-block">{{ file.name }}</strong></span
            >
            <span class="d-block">({{ file.path }})</span>
          </li>
        </ul>
      </div>
      <div class="d-inline-block" ngbDropdown #fileActions="ngbDropdown">
        <button
          class="btn btn-primary ml-2"
          id="dropdownManual"
          ngbDropdownAnchor
          (focus)="fileActions.open()"
        >
          <i *ngIf="!loading" class="fa fa-plus mr-1"></i>
          <div
            *ngIf="loading"
            class="spinner-border text-white mr-1"
            style="height: 1rem; width: 1rem"
            role="status"
          ></div>
          Actions
        </button>

        <div ngbDropdownMenu aria-labelledby="dropdownManual">
          <div class="text-bold bg-light padding-10">Add</div>

          <button ngbDropdownItem (click)="folderModal = true">
            <i class="fa fa-folder mr-1"></i>Add Folder
          </button>
          <button ngbDropdownItem (click)="fileInput.click()">
            <i class="fa fa-file mr-1"></i>Add File(s)
          </button>
          <div class="dropdown-divider no-mrg"></div>
          <div class="text-bold bg-light padding-10">Utilies</div>
          <button ngbDropdownItem (click)="handleSync()">
            <i class="fa fa-sync-alt mr-1"></i>Scan
          </button>
          <button ngbDropdownItem (click)="handleZip()">
            <i class="fa fa-file-archive mr-1"></i>Download Folder
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="list-group px-1">
    <div
      *ngFor="let folder of filteredFolders"
      class="d-flex justify-content-between align-items-center list-group-item p-0"
    >
      <a
        role="button"
        (click)="openFolder(folder)"
        [style.pointer-events]="
          disabledFiles.includes(folder.uuid) ? 'none' : 'auto'
        "
        [style.opacity]="disabledFiles.includes(folder.uuid) ? 0.5 : 1"
        class="list-group-item-action px-0 py-2 h-100"
      >
        <span><i class="fa fa-folder"></i> {{ folder.name }}</span>
      </a>

      <egi-file-btn-group
        *ngIf="showButtons"
        [file]="folder"
        [showEdit]="true"
        [currentPath]="currentPath"
        [limitToFolder]="limitToFolder"
        (edit)="getFiles(currentPath[currentPath.length - 1])"
        (delete)="handleDelete()"
      ></egi-file-btn-group>
    </div>

    <div
      *ngFor="let symlink of filteredSymlinks"
      class="d-flex justify-content-between align-items-center list-group-item p-0"
    >
      <a
        role="button"
        (click)="openFolder(symlink)"
        [style.pointer-events]="
          disabledFiles.includes(symlink.uuid) ? 'none' : 'auto'
        "
        [style.opacity]="disabledFiles.includes(symlink.uuid) ? 0.5 : 1"
        class="list-group-item-action px-0 py-2 h-100"
      >
        <span><i class="fa fa-link"></i> {{ symlink.name }}</span>
      </a>

      <egi-file-btn-group
        *ngIf="false"
        [file]="symlink"
        [showEdit]="true"
        [currentPath]="currentPath"
        [limitToFolder]="limitToFolder"
        (edit)="getFiles(currentPath[currentPath.length - 1])"
        (delete)="handleDelete()"
      ></egi-file-btn-group>
    </div>

    <div
      *ngFor="let file of filteredFiles"
      class="list-group-item d-flex justify-content-between align-items-center px-0"
      style="color: #495057"
    >
      <span><i class="fa fa-file"></i> {{ file.name }}</span>
      <egi-file-btn-group
        *ngIf="showButtons"
        [file]="file"
        [showEdit]="true"
        [currentPath]="currentPath"
        [limitToFolder]="limitToFolder"
        (edit)="getFiles(currentPath[currentPath.length - 1])"
        (delete)="handleDelete()"
      ></egi-file-btn-group>
    </div>
    <div
      *ngIf="!(files.length || folders.length || symlinks.length)"
      class="list-group-item px-0"
    >
      No Folders{{ showFiles ? ' or Files' : '' }}
    </div>
  </div>
</div>

<egi-modal
  *ngIf="folderModal"
  [show]="folderModal"
  size="lg"
  (close)="handleModalClose()"
>
  <div header>
    <h3>Creating Folder</h3>
  </div>
  <div *ngIf="folderModal">
    <div class="d-flex align-items-center flex-wrap">
      <h5 class="mb-0" style="color: #2a7de1">{{ getCurrentPathName() }} /</h5>

      <input
        type="text"
        class="form-control form-control-sm ml-2"
        style="width: 200px; max-width: 100%"
        placeholder="New Folder Name"
        [(ngModel)]="folderName"
      />
    </div>
    <div class="d-flex justify-content-end mt-2">
      <button
        class="btn btn-primary"
        (click)="onFolderCreate()"
        [disabled]="!folderName"
      >
        <div
          style="width: 1rem; height: 1rem"
          *ngIf="modalLoading"
          class="spinner-border text-white"
          role="status"
        ></div>
        Create
      </button>
      <button class="btn btn-secondary ml-2" (click)="handleModalClose()">
        Cancel
      </button>
    </div>
  </div>
</egi-modal>
